<template>
  <router-view />
  <lock-screen />
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";

import { useAppLock } from "@/composables/lock/useAppLock";
import { user } from '@/shared/state';
export default defineComponent({
  setup() {
    const currentStyle = ref(localStorage.getItem("style") || "leftStyle");
    const { setPin, startInactivityChecker } = useAppLock();

    const loadStyle = (style) => { };
    onMounted(() => {
      const pin = localStorage.getItem("gymya_pin");
      // first time
      if (!pin) {
          setPin(user?.value?.pin ?? "1230");
      }
      startInactivityChecker();
    });

    return {
      loadStyle,
    };
  },
});
</script>
<style lang="scss">
.form-check-inline {
  width: 100%;
}

.modal-loader {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;
  background-color: #000;
  opacity: 0.5;
}

.form-control.readonly {
  background-color: #e9e9e9 !important;
}

.accordion-header button {
  font-weight: bold;
}

.modal-footer {
  justify-content: space-between !important;
}

.modal-footer button.btn {
  width: 38% !important;
}

#avatar {
  margin: auto;
  background-color: antiquewhite;
  background-size: cover;
  height: 180px;
  border: 3px solid #0af;
  border-radius: 3%;
  transition: background ease-out 200ms;
  background-repeat: no-repeat !important;
  background-size: contain !important;
  background-position: center !important;
  width: 100%;
  object-fit: contain;
}

.image-list-product {
  background-repeat: no-repeat !important;
  background-size: contain !important;
  background-position: center !important;
  width: 80px;
  height: 80px;
  max-width: 80px;
  max-height: 80px;
  border-radius: 3%;
  margin: auto;
  position: relative;
}

.changeImage::after {
  content: "X";
  width: 100%;
  height: 100%;
  position: absolute;
  inset-inline-end: 0;
  top: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 80px;
}
</style>
